module.exports = __webpack_public_path__ + "img/prefeitura.dec35b15.jpg";